import { SizerState } from '../sizer-state.service';
import { State } from '../state.service';
import { EDynEvents } from './enums/events.enum';
import { EModeValue } from './enums/mode.enum';
import { logger } from '../logger.service';
import { Dynamics } from './dynamics';
import { IClickToActDataApi } from './interfaces/api/click-to-act.interface';
import { EEntity } from './enums/entity.enum';
import { DynamicsV2 } from './dynamics-v2';
import { onPageNavigateState } from '../onpagenavigate-state';
import { EDynV2SessionEvent } from './enums/v2/session-event.enum';
import { IDynV2Session } from './interfaces/v2/dyn-session.interface';
import { commonMakeCall } from '@/shared/helpers/common-make-call.helper';
import { SipJs } from '../sip-js.service';

export const DYN_ACTIONS = {
  clickToAct: {
    event: EDynEvents.CLICK_TO_ACT,
    action: (data: string) => {
      logger.log(`[DYNAMICS] Dynamics action: `, data);
      const params: IClickToActDataApi = JSON.parse(data);

      if (SipJs.sessions?.length) {
        return;
      }

      const { isDialerActive } = State.state$.getValue();

      if (isDialerActive) {
        return;
      }

      switch (params.entityLogicalName) {
        case EEntity.CONTACT:
          Dynamics.searchContacts({
            id: params.entityId,
            phone: params.value,
            text: params.value,
            isExactPhoneSearch: true,
          }).then((entities) => {
            commonMakeCall(entities, params.value);
          });
          return;
        case EEntity.ACCOUNT:
          Dynamics.searchAccounts({
            id: params.entityId,
            phone: params.value,
            text: params.value,
            isExactPhoneSearch: true,
          }).then((entities) => {
            commonMakeCall(entities, params.value);
          });
          return;
        case EEntity.LEAD:
          Dynamics.searchLeads({
            id: params.entityId,
            phone: params.value,
            text: params.value,
            isExactPhoneSearch: true,
          }).then((entities) => {
            commonMakeCall(entities, params.value);
          });
          return;
        default:
          Dynamics.searchEntityByCalls({ phone: params.value }).then(
            (entities) => {
              commonMakeCall(entities, params.value);
            },
          );
      }
    },
  },
  modeChanged: {
    event: EDynEvents.MODE_CHANGED,
    action: (res: string) => {
      const data = JSON.parse(res);
      const { value }: { value: EModeValue } = data;

      switch (value) {
        case EModeValue.MINIMIZE: {
          SizerState.setModeChangeState(EModeValue.MINIMIZE);
          break;
        }
        case EModeValue.DOCK: {
          SizerState.setModeChangeState(EModeValue.DOCK);
          break;
        }
        case EModeValue.HIDE: {
          SizerState.setModeChangeState(EModeValue.HIDE);
          break;
        }
      }
    },
  },
  pageNavigation: {
    event: EDynEvents.PAGE_NAVIGATE,
    action: (res: string) => {
      if (res) onPageNavigateState.setModeChangeState(JSON.parse(res));
    },
  },
  onSessionSwitched: {
    event: EDynEvents.ON_SESSION_SWITCHED,
    action: (res: string) => {
      const resObj: Partial<IDynV2Session> = JSON.parse(res);
      DynamicsV2.pathSession(resObj);
      const session = DynamicsV2.getSession(resObj.sessionId);

      DynamicsV2.events$.next({
        event: EDynV2SessionEvent.SWITCHED,
        session,
      });
    },
  },
  onSessionClosed: {
    event: EDynEvents.ON_SESSION_CLOSED,
    action: (res: string) => {
      const resObj: Partial<IDynV2Session> = JSON.parse(res);
      const session = DynamicsV2.getSession(resObj.sessionId);
      DynamicsV2.removeSession(resObj.sessionId);
      DynamicsV2.events$.next({
        event: EDynV2SessionEvent.CLOSED,
        session,
      });

      if (DynamicsV2.isEmptySessionList()) {
        DynamicsV2.events$.next({
          event: EDynV2SessionEvent.EMPTY,
          session: null,
        });
      }
    },
  },
};
